import React from 'react';
import PropTypes from 'prop-types';
import SimpleButton from '../components/atoms/SimpleButton';
import { connect } from 'react-redux';
import ReactTimeout from 'react-timeout';
import { contentChange } from '../actions/content';

var AppConfig = require('../config.json');
 
class PayeverObserver extends React.Component {
    constructor(props) {
      super(props);
      this.goBack = this.goBack.bind(this);
      this.checkActive = this.checkActive.bind(this);
      this.prepareGoBack = this.prepareGoBack.bind(this);
      this.state = {back: false};
    }
    checkActive() {
      return this.props.payever.checkout && this.props.pathname !== "/"+AppConfig.links.checkout.url && this.props.pathname !== "/"+AppConfig.links.finished.url;
    }
    goBack() {
      let link = AppConfig.links.checkout.url;
      this.props.dispatch(contentChange(link));
    }
    prepareGoBack(evt) {
      if(this.state.back) {
        return;
      }
      this.setState({ back:true });
      this.props.setTimeout(this.goBack, 300);
    }

    componentDidUpdate(prevProps, prevState) {
      if(this.props.payever.checkout &&
        (this.props.pathname === "/"+AppConfig.links.checkout.url ||
        this.props.pathname === "/"+AppConfig.links.finished.url) &&
        this.state.back
        ) {
        this.setState({ back:false });
      }
    }

    render () {
        return (
            <div id="payeverobserver" className={`${this.checkActive()?"active":"inactive"} ${this.state.back?"dissolve":""}`}>
              <div className="overlayinner">
              <h4>{this.props.headline}</h4>
              <SimpleButton children="Gehen Sie zurück zum Checkout." onClick={(evt) => this.prepareGoBack(evt)} />
              </div>
            </div>
        );
    }

}


PayeverObserver.propTypes = {
  headline: PropTypes.string
}

PayeverObserver.defaultProps = {
  headline: "Hinweis: Ihr Ratenkauf Vorgang wurde bereits ausgeführt."
}

const mapStateToProps = (state) => {
  return {
    payever: state.payever,
    pathname: state.routing.location.pathname
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReactTimeout(PayeverObserver));


// WEBPACK FOOTER //
// ./src/utils/PayeverObserver.js